import { createTheme } from "@mui/material/styles";

// Define brand colors
const brandColors = {
  primary: {
    main: "#CC1042",
    light: "#FF1A5D",
    dark: "#990C32",
    contrastText: "#FFFFFF",
  },
  secondary: {
    main: "#333333",
    light: "#4F4F4F",
    dark: "#1A1A1A",
    contrastText: "#FFFFFF",
  },
  grey: {
    50: "#FAFAFA",
    100: "#F5F5F5",
    200: "#EEEEEE",
    300: "#E0E0E0",
    400: "#BDBDBD",
    500: "#9E9E9E",
    600: "#757575",
    700: "#616161",
    800: "#424242",
    900: "#212121",
  },
};

// Define typography settings
const typography = {
  fontFamily: "Poppins, sans-serif",
  h1: {
    fontWeight: 700,
    fontSize: "24px",
    lineHeight: 1.2,
    letterSpacing: "-0.01em",
  },
  h2: {
    fontWeight: 600,
    fontSize: "20px",
    lineHeight: 1.3,
    letterSpacing: "-0.005em",
  },
  h3: {
    fontWeight: 500,
    fontSize: "16px",
    lineHeight: 1.4,
  },
  body1: {
    fontWeight: 400,
    fontSize: "14px",
    lineHeight: 1.5,
  },
  body2: {
    fontWeight: 400,
    fontSize: "12px",
    lineHeight: 1.5,
  },
  button: {
    fontWeight: 500,
    fontSize: "14px",
    textTransform: "none",
  },
};

// Define component overrides
const components = {
  MuiButton: {
    styleOverrides: {
      root: {
        borderRadius: "8px",
        padding: "8px 16px",
        fontWeight: 500,
      },
      contained: {
        boxShadow: "none",
        "&:hover": {
          boxShadow: "none",
        },
      },
    },
  },
  MuiTextField: {
    styleOverrides: {
      root: {
        "& .MuiOutlinedInput-root": {
          borderRadius: "8px",
        },
      },
    },
  },
  MuiCard: {
    styleOverrides: {
      root: {
        borderRadius: "12px",
        boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.1)",
      },
    },
  },
  MuiChip: {
    styleOverrides: {
      root: {
        borderRadius: "16px",
        height: "24px",
      },
    },
  },
  MuiDialog: {
    styleOverrides: {
      paper: {
        borderRadius: "12px",
      },
    },
  },
};

// Create and export theme
const theme = createTheme({
  palette: {
    primary: brandColors.primary,
    secondary: brandColors.secondary,
    grey: brandColors.grey,
    background: {
      default: "#FFFFFF",
      paper: "#FFFFFF",
    },
  },
  typography,
  components,
  spacing: 8, // Base spacing unit of 8px
  shape: {
    borderRadius: 8,
  },
  shadows: [
    "none",
    "0px 2px 4px rgba(0, 0, 0, 0.05)",
    "0px 4px 8px rgba(0, 0, 0, 0.1)",
    "0px 8px 16px rgba(0, 0, 0, 0.1)",
    "0px 16px 24px rgba(0, 0, 0, 0.1)",
    // ... rest of the shadows remain default
    ...Array(20).fill("none"),
  ],
});

export default theme;
